import {Component, Inject, OnInit } from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { ClientProfileService, UserService, AlertService, FileBlobService } from "../../_services";
import {WorkstreamService} from "../../_services/workstream.service";
import { LoginHelper, Role, StringsHelper } from "../../helpers";
import { SelectControlItemComponent } from "../selectControlItem/select-control-item.component";
import { User } from "../../_models";
import { workStreamItemAttachment } from "../../_models/workStreamItemAttachment";
import { saveAs as importedSaveAs } from 'file-saver';
import {DictionaryItem} from "../../_models/dictionaryItem";
import {DictionaryService} from "../../_services/dictionary.service";

@Component({
    standalone: false,
  selector: "workstream-item",
  templateUrl: 'workstream-item.component.html',
  styleUrls: ['./workstream-item.component.scss'],
})

export class WorkstreamItemComponent implements OnInit {
  users: any;
  workstreamItem: any;
  controlItems: any;
  currentUser: User;
  topics: DictionaryItem[];
  documentCols: any[] = [
    { 'field': 'date', 'header': 'Date', width: '8em' },
    { 'field': 'name', 'header': 'Artifact' },
    { 'field': 'submitterId', 'header': 'Submitter' },
    { 'field': 'note', 'header': 'Notes' },
  ];
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public userService: UserService,
    public workstreamService: WorkstreamService,
    public dictionaryService: DictionaryService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<WorkstreamItemComponent>,
    public alertService: AlertService,
    public fileBlobService: FileBlobService,
  ) {
    this.workstreamItem = data.entity;
    this.controlItems = [];
  }
  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.userService.getActiveShort().subscribe(u => this.users = u)
    this.dictionaryService.get(['Topic']).subscribe(t => this.topics = t);
    this.workstreamService.getWorkstreamControlItems(this.workstreamItem.workstreamItemId)
      .subscribe(r => {
        this.controlItems = r
      });
  }

  save(): void {
    if (this.workstreamItem.wsid == "" || this.workstreamItem.type == "") {
      this.alertService.error("Please fill required fields");
      return;
    }

    this.workstreamItem.controlItems = this.controlItems;
    this.workstreamService.saveWorkstreamItem(this.workstreamItem).subscribe(r => this.close());
  }

  close(): void {
    this.dialogRef.close();
  }

  isMaster() {
    let currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    return currentUser.role == Role.KingAdmin
  }

  addControlItem() {
    let config: MatDialogConfig = {
      width: "90%",
      height: "90%",
      data: {
        except: this.controlItems || []
      }
    };

    const selectDialogRef = this.dialog.open(SelectControlItemComponent, config);

    selectDialogRef.afterClosed().subscribe((data: any) => {
      if (data)
        this.controlItems.push(data);
    });
  }

  removeControlItem(c) {
    this.controlItems = this.controlItems.filter(v => v !== c);
  }
  getFullNameById(id: number) {
    return StringsHelper.getFullName(
      this.users.find((u) => u.userId == id) || <any>{}
    );
  }
  public DownloadAttachment(fileName: string, isPath: boolean = false) {
    if (isPath && fileName.startsWith('null')) {
      fileName = fileName.substring(4);
    }
    this.fileBlobService
      .downloadWorkStreamFile(
        isPath ? fileName.replace(/^.*[\\\/]/, '') : fileName,
        isPath
          ? fileName.replace(/[^\\/]*$/, '')
          : 'WorkStreams/' +
          this.workstreamItem.workstreamName
      )
      .subscribe(
        (blob) => {
          importedSaveAs(new Blob([blob]), fileName);
        },
        (error) => {
          const errorMessage =
            error.status == 401
              ? "The logged in user does not have access to the file's location. "
              : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        }
      );
  }
  saveAttachment(item) {
    this.fileBlobService.updateWorkStreamAttachment(item).subscribe(
      (res) => { },
      (error) => {
        const errorMessage = 'An error occurred while updating evidence.';
        this.alertService.error(errorMessage);
      }
    );
  }
  deleteAttachment(item) {
    if (item.attachmentId == 0) {
      this.workstreamItem.workstreamItemDocuments.splice(
        this.workstreamItem.workstreamItemDocuments.indexOf(item),
        1
      );
      return;
    }
    this.fileBlobService.deleteWorkStreamItemDocument(item.attachmentId).subscribe(
      (res) => {
        this.workstreamItem.workstreamItemDocuments.splice(
          this.workstreamItem.workstreamItemDocuments.indexOf(item),
          1
        );
      },
      (error) => {
        const errorMessage = 'An error occurred while deleting attachment.';
        this.alertService.error(errorMessage);
      }
    );
  }
  public UploadAttachment(event, item) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService
        .postWorkStreamDocument(
          this.workstreamItem.workstreamName,
          file,
          LoginHelper.getUserId(),
          this.workstreamItem.workstreamItemId == undefined ? 0 : this.workstreamItem.workstreamItemId.toString(),
          item.attachmentId
        )
        .subscribe(
          (res) => {
            item.attachmentId = res.attachmentId;
            item.name = res.name;
            item.internalName = res.internalName;
            item.date = res.date;
            item.projectControlItemId = res.projectControlItemId;
            item.submitterId = res.submitterId;
          });
    }
  }

  public AddAttachment(event) {
    this.workstreamItem.workstreamItemDocuments = this.workstreamItem.workstreamItemDocuments || [];
    this.workstreamItem.workstreamItemDocuments.push(<workStreamItemAttachment>{
      name: '',
      attachmentId: 0,
      editMode: true,
      workstreamItemId:
        this.workstreamItem.workstreamItemId,
      submitterId: this.currentUser.userId,
      date: new Date(),
    });
  }
}
